<div class="new-connection" [formGroup]="form" (keydown.Space)="$event.stopPropagation()">
    <div class="new-connection_step-container">
        <div class="new-connection_step-title">
            1. Create your connection key in your marketplace
        </div>
        <app-button [buttonSize]="'action'" (click)="openShipstationPage()">Get Key</app-button>
    </div>
    <div class="new-connection_step-container">
        <div class="new-connection_step-title">
            2. Enter API Key and API Secret.
        </div>
        <div class="new-connection_data-inputs">
            <div class="input-container">
                <label for="" class="input-container_label">API Key</label>
                <input type="text" formControlName="accessKey" class="input-container_input input-container_input--thin"
                    [placeholder]="'API Key'" />
            </div>

            <div class="input-container">
                <label for="" class="input-container_label">API Secret</label>
                <input formControlName="secretKey" type="text" class="input-container_input input-container_input--thin"
                    [placeholder]="'API Secret'" />
            </div>
        </div>
    </div>
    <div class="new-connection_action">
        <app-button (click)="cancel()" [buttonStyle]="'wire'">Cancel</app-button>
        <app-button (click)="onSubmit()" [isDisabled]="isDisabled" [spin]="isSpin">Save</app-button>
    </div>
</div>